<template>
  <div>
    <v-form ref="userOutForm">
      <v-layout wrap px-3 pt-3 pb-2 v-if="outUsers">
        <v-flex xs12 pl-0 pt-0 pb-3
          ><h4 class="text-xs-left font-weight-light">
            <v-icon small class="mr-1">info</v-icon>
            Os usuários cadastrados aqui, receberão os alertas de todos os
            documentos e contratos referentes a este condomínio.
          </h4></v-flex
        >
        <v-flex xs12 pl-0 pt-0>
          <h4 class="text-xs-left">Responsável não cadastrado no sistema</h4>
        </v-flex>
        <v-flex xs4 pl-0 pt-0>
          <v-text-field
            type="text"
            v-model="userNameOut"
            label="Nome"
            :rules="$store.state.formRules.required"
            required
            :disabled="disableFields"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 pl-2 pt-0>
          <v-text-field
            type="text"
            v-model="userMailOut"
            label="Email"
            :rules="$store.state.formRules.emailRules"
            required
            :disabled="disableFields"
          ></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-speed-dial
            v-model="fab"
            :top="true"
            :bottom="false"
            :right="false"
            :left="false"
            direction="right"
            :open-on-hover="false"
            transition="slide-x-transition"
          >
            <template v-slot:activator v-if="!disableFields">
              <v-btn v-model="fab" small color="primary" dark fab>
                <v-icon>add</v-icon>
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <v-btn
              @click="
                addResponsible(
                  {
                    name: userNameOut,
                    email: userMailOut,
                    out: true,
                    add: true,
                  },
                  1
                )
              "
              style="font-size: 10px"
              small
              color="blue darken-2"
              dark
              >Operacional</v-btn
            >
            <v-btn
              @click="
                addResponsible(
                  {
                    name: userNameOut,
                    email: userMailOut,
                    out: true,
                    add: true,
                  },
                  2
                )
              "
              style="font-size: 10px"
              small
              color="blue darken-2"
              dark
              >Administrativo</v-btn
            >
          </v-speed-dial>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout wrap px-0>
      <v-flex sm6 pl-3 pr-4>
        <h4 class="text-xs-left pt-3">Responsáveis operacionais</h4>
        <p class="text-xs-left caption">
          Os usuários operacionais receberão todos os avisos possíveis sobre a
          situação, status e vencimento em relação aos dias de aviso.
        </p>
        <v-combobox
          return-object
          v-model="userOne"
          :items="allUsersOne"
          item-text="name"
          item-value="id"
          append-icon="library_add"
          label="Selecione"
          @click:append="addResponsible(userOne, 1)"
          :disabled="disableFields"
        >
          <template v-slot:item="{ item }">
            <v-list-tile-content>
              <v-list-tile-title v-html="item.name"></v-list-tile-title>
              <v-list-tile-sub-title class="mb-3">
                <b>{{ item.email }}</b>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </v-combobox>
        <v-data-table
          :items="selectedUserOne"
          class="elevation-1"
          hide-actions
          hide-headers
        >
          <template v-slot:items="props">
            <td class="text-xs-left pl-2">
              <v-list-tile-content>
                <v-list-tile-title>{{ props.item.name }}</v-list-tile-title>
                <v-list-tile-sub-title class>
                  <b>{{ props.item.email }}</b>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </td>
            <td class="text-xs-right pr-2">
              <v-btn flat v-if="!disableFields" icon @click="removeResponsible(props.item, 1)">
                <v-icon small>delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>
            <p class="pt-3">Nenhum responsável selecionado</p>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex sm6 pl-4 pr-4>
        <h4 class="text-xs-left pt-3">Responsáveis administrativos</h4>
        <p class="text-xs-left caption">
          Os usuários adminstrativos receberão alertas quando o prazo de
          vencimento estiver com apenas 20% dos dias de aviso.
        </p>
        <v-combobox
          return-object
          v-model="userTwo"
          :items="allUsersTwo"
          item-text="name"
          item-value="id"
          append-icon="library_add"
          label="Selecione"
          @click:append="addResponsible(userTwo, 2)"
          :disabled="disableFields"
        >
          <template v-slot:item="{ item }">
            <v-list-tile-content>
              <v-list-tile-title v-html="item.name"></v-list-tile-title>
              <v-list-tile-sub-title class="mb-3">
                <b>{{ item.email }}</b>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </v-combobox>
        <v-data-table
          :items="selectedUserTwo"
          class="elevation-1"
          hide-actions
          hide-headers
        >
          <template v-slot:items="props">
            <td class="text-xs-left pl-2">
              <v-list-tile-content>
                <v-list-tile-title>{{ props.item.name }}</v-list-tile-title>
                <v-list-tile-sub-title class>
                  <b>{{ props.item.email }}</b>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </td>
            <td class="text-xs-right pr-2">
              <v-btn flat v-if="!disableFields" icon @click="removeResponsible(props.item, 2)">
                <v-icon small>delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>
            <p class="pt-3">Nenhum responsável selecionado</p>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  name: 'RESPONSABLE-NEW',

  data () {
    return {
      fab: false,
      userNameOut: '',
      userMailOut: '',
      userOne: '',
      userTwo: '',
      allUsersOne: [],
      allUsersTwo: [],
      selectedUserOne: [],
      selectedUserTwo: []
    }
  },

  props: {
    outUsers: Boolean,
    clearDataEdit: Function,
    urlDel: String,
    dataEdit: Array,
    updateResponsibles: Function,
    dialog: Boolean,
    disableFields: { type: Boolean, default: false }
  },

  mounted () {
    this.getUsers()
  },

  watch: {
    dialog (v) {
      if (!v) {
        this.userOne = ''
        this.userTwo = ''

        this.allUsersOne.map((i) => {
          i.disabled = false
          return i
        })

        this.allUsersTwo.map((i) => {
          i.disabled = false
          return i
        })

        this.selectedUserOne = []
        this.selectedUserTwo = []
      } else {
        if (!this.dataEdit || !this.dataEdit.length) return

        for (let i = 0; i < this.dataEdit.length; i++) {
          let responsible = {
            idResp: this.dataEdit[i].id,
            level: this.dataEdit[i].level,
            id: this.dataEdit[i].user_id,
            out: !this.dataEdit[i].user_id,
            name: this.dataEdit[i].notify_name,
            email: this.dataEdit[i].notify_email,
            disabled: false
          }

          this.addResponsible(responsible, responsible.level)
        }
      }
    }
  },

  methods: {
    deleteResponsible (id) {
      let obj = {
        url: this.urlDel + id,
        query: '',
        method: 'delete'
      }

      this.clearDataEdit(id)

      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `Responsável removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
      })
    },

    removeOutUser (data, type) {
      if (data.idResp) {
        this.deleteResponsible(data.idResp)
      }

      let responsible = {
        remove: true,
        level: type,
        outUser: true,
        notify_email: data.email,
        user_id: data.id
      }

      this.$emit('updateResponsibleList', responsible)

      if (type === 1) {
        let index = this.selectedUserOne.findIndex((user) => {
          return user.email === data.email
        })

        this.selectedUserOne.splice(index, 1)
      } else {
        let index = this.selectedUserTwo.findIndex((user) => {
          return user.email === data.email
        })

        this.selectedUserTwo.splice(index, 1)
      }
    },

    removeResponsible (data, type) {
      if (!data.id) {
        this.removeOutUser(data, type)
        return
      }
      if (data.idResp) {
        this.deleteResponsible(data.idResp)
      }
      let responsible = {
        remove: true,
        level: type,
        user_id: data.id
      }
      if (type === 1) {
        let ind = this.allUsersOne.findIndex((user) => user.id === data.id)
        this.allUsersOne[ind].disabled = false
      } else {
        let ind = this.allUsersTwo.findIndex((user) => user.id === data.id)
        this.allUsersTwo[ind].disabled = false
      }

      this.$emit('updateResponsibleList', responsible)

      if (type < 2) {
        let index = this.selectedUserOne.findIndex((user) => {
          return user.id === data.id
        })
        this.selectedUserOne.splice(index, 1)
      } else {
        let index = this.selectedUserTwo.findIndex((user) => {
          return user.id === data.id
        })
        this.selectedUserTwo.splice(index, 1)
      }
    },

    addResponsible (data, type) {
      if (!data) return

      let responsible = {
        id: data.idResp,
        level: type,
        user_id: data.id,
        notify_name: data.name,
        notify_email: data.email
      }

      if (data.out && data.add) {
        if (!this.$refs.userOutForm.validate()) return
      }

      this.$emit('updateResponsibleList', responsible)

      if (type == 1) {
        //let ind = this.selectedUserOne.findIndex((user) => user.id == data.id)

        //if (ind < 0) {
          let index = this.allUsersOne.findIndex((user) => user.id == data.id)

          if (index >= 0) {
            this.allUsersOne[index].disabled = true
          }

          this.selectedUserOne.push(data)
          this.userOne = ''
        //}
      } else {
        //let ind = this.selectedUserTwo.findIndex((user) => user.id == data.id)

        //if (ind < 0) {
          let index = this.allUsersTwo.findIndex((user) => user.id == data.id)

          if (index >= 0) {
            this.allUsersTwo[index].disabled = true
          }

          this.selectedUserTwo.push(data)
          this.userTwo = ''
        //}
      }

      this.$refs.userOutForm.reset()
    },

    getUsers () {
      let obj = {
        url: '/api/user',
        query: {},
        method: 'get'
      }

      this.$store.dispatch('request/doRequest', obj).then((response) => {
        let users = response.data.map((user) => {
          user.disabled = false
          return user
        })

        let two = users.map((el) => {
          return { ...el }
        })

        this.allUsersOne = [...users]
        this.allUsersTwo = [...two]
      })
    }
  }
}
</script>
